
import { Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EmailContactProps {
  type: string;
  value: string;
  href: string;
}

const EmailContact = ({ type, value, href }: EmailContactProps) => {
  return (
    <div className="group flex items-center justify-between p-3 bg-white rounded-lg border border-gray-200 hover:border-nexx-green hover:shadow-md transition-all duration-300 hover:-translate-y-0.5">
      <div className="flex items-center space-x-2">
        <div className="p-1.5 bg-gray-100 rounded-full group-hover:bg-nexx-green group-hover:scale-110 transition-all duration-300">
          <Mail className="h-3 w-3 text-gray-600 group-hover:text-white" />
        </div>
        <div>
          <div className="font-medium text-gray-900 text-xs">{type}</div>
          <a 
            href={href}
            className="text-nexx-green hover:text-green-700 transition-colors text-xs"
          >
            {value}
          </a>
        </div>
      </div>
      <Button 
        asChild
        variant="outline"
        size="sm"
        className="border-nexx-green text-nexx-green hover:bg-nexx-green hover:text-white transition-all duration-300 text-xs px-2 py-1 h-7"
      >
        <a href={href}>
          Email
        </a>
      </Button>
    </div>
  );
};

export default EmailContact;
